import styled from 'styled-components';

const EndorsementsStyles = styled.section`
  padding: ${(props) => (props?.backgroundImage ? '3rem 0' : 0)};

  .header {
    margin: 0 0 3rem;
    text-align: center;

    .heading {
      display: flex;
      justify-content: center;
      align-items: center;

      .heart {
        width: 1.6rem;
        margin: 0 0 0 0.4rem;
      }
    }
  }

  .endorsements {
    margin: 0 auto;
    padding: 0;
    list-style: none;
    overflow: hidden;

    .endorsement {
      .inner {
        display: block;
        height: 100%;
        padding: 2rem;
        background: ${(props) =>
          props?.backgroundImage
            ? 'var(--color-swiss-coffee)'
            : 'var(--color-sand)'};
      }

      .quote-mark {
        margin: 0 0 1.3rem;
      }

      .quote {
        margin: 0 0 1.5rem;

        p {
          margin: 0 0 1rem;
          font-size: 1rem;
        }
      }

      .meta {
        font-size: 1rem;
        text-transform: none;
        color: var(--color-graphite);
      }
    }

    &.masonry,
    &.selection {
      .endorsement {
        width 100%;
        margin: 0 0 2rem;

        &:nth-child(even) .inner {
          background-color: var(--color-swiss-coffee);
        }
      }
    }

    &.selection-slider .inner {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;

      .meta {
        margin-top: auto;
      }
    }
  }

  .read-more {
    margin-top: 4rem;
  }

  @media (min-width: 768px) {
    padding: ${(props) => (props?.backgroundImage ? '5rem 0' : 0)};

    .endorsements {
      max-width: ${(props) => (props?.condensed ? '70rem' : 'none')};

      &.masonry,
      &.selection {
        .endorsement {
          margin: 0 2rem 2rem 0;
        }
      }

      &.masonry .endorsement {
        width: 19.375rem;
        width: calc(50% - 2rem);
      }

      &.selection {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        .endorsement {
          width: calc(50% - 2rem);

          &:nth-child(even) {
            background: ${(props) =>
              props?.backgroundImage
                ? 'var(--color-swiss-coffee)'
                : 'var(--color-sand)'};
          }
        }
      }
    }
  }

  @media (min-width: 992px) {
    .endorsements {
      &.masonry .endorsement {
        width: 17.5rem;
        width: calc(33.333% - 2rem);
      }

      &.selection .endorsement {
        width: calc(33.333% - 2rem);
      }
    }
  }

  @media (min-width: 1400px) {
    .endorsements {
      &.masonry,
      &.selection {
        .endorsement {
          width: calc(25% - 2rem);
          margin: 0 2rem 2rem 0;
        }
      }
    }
  }
`;

export default EndorsementsStyles;
